import { ref } from 'vue';
import { pendingTransactionUpdateId, inflightCategoryUpdate } from '@/components/elements/transactionUpdateState';
// Per-page hook for the post-category-change spinner handoff.
//
// On mount, the landing page (AccountPage / MoneyPage / SpendingAnalysisPage)
// calls takePending() to adopt the global pendingTransactionUpdateId. That
// shows the row spinner immediately while the page's own SWR+poll fetch waits
// for the server payload to reflect the change; when fresh data lands the page
// clears updatingTransactionId via the !isStale callback.
//
// `pendingTransactionUpdateId` is single-shot (consumed on first take) so the
// spinner only appears on the first landing page after the write. If the user
// bounces back into TDP and out again while the update is still in flight,
// we fall back to the long-lived `inflightCategoryUpdate` marker so the second
// landing page still shows the spinner. The marker is owned by TDP and only
// cleared when its polls complete.
export function useTransactionUpdateHandoff() {
    const updatingTransactionId = ref(null);
    function takePending() {
        // pendingTransactionUpdateId is only meaningful while the write is still
        // in flight. If inflightCategoryUpdate has been cleared (e.g. the user
        // was on TDP itself when its polls completed, then navigated back here),
        // the pending hint is stale — adopting it would show a row spinner that
        // nothing will ever clear, since the landing page only clears it on a
        // pollUntilChanged response that won't happen.
        const inflight = inflightCategoryUpdate.value;
        const id = inflight ? (pendingTransactionUpdateId.value || inflight.id) : null;
        if (id)
            updatingTransactionId.value = id;
        pendingTransactionUpdateId.value = null;
        return { id };
    }
    return { updatingTransactionId, takePending };
}
